import { render } from "./BookMark.vue?vue&type=template&id=d040f4ec"
import script from "./BookMark.vue?vue&type=script&lang=js"
export * from "./BookMark.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__